import * as ActionTypes from 'actions/app'

const initialState = {
  notify: {
    active: false,
    message: '',
    alertType: 'accept',
    alert: false,
  },
  isFetching: false,
  isError: false,
  fetched: false,
  partnerSideBarInfo: {},
}

export default function job(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.APP_NOTIFY:
      return Object.assign({}, state, {
        ...state,
        notify: {
          active: true,
          alertType: action.alertType,
          message: action.message,
          alert: true,
          gotoSubs: action.gotoSubs,
        },
      })
    case ActionTypes.APP_CLEAR_NOTIFICATION:
      return Object.assign({}, state, {
        ...state,
        notify: {
          active: false,
        },
      })
    case ActionTypes.SIDEBARINFO_GETTING_SIDEBARINFO:
      return {
        ...state,
        isFetching: true,
      }
    case ActionTypes.SIDEBARINFO_RECEIVED_SIDEBARINFO:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        partnerSideBarInfo: action.partnerSideBarData,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/app.js